import React, { useEffect, useRef, useState } from 'react';
import { Send, MapPin, Phone, Mail } from 'lucide-react';
import mapImage from '../Images/s12.jpeg'; // Assuming s12.jpg is the map image
import './LocationCTA.css';

const LocationCTA = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 } 
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) observer.unobserve(sectionRef.current);
        };
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Enquiry Submitted!");
        // Add your actual form submission logic here (e.g., Axios post)
    };

    return (
        <section className="location-cta-section" id="location-cta" ref={sectionRef}>
            <div className="container">
                <div className="cta-grid">
                    
                    {/* --- LEFT SIDE: Location Map Image --- */}
                    <div className={`map-image-wrapper ${isVisible ? 'fade-in-left' : ''}`}>
                        {/* <div className="map-overlay-text">
                            <h3>Strategic Investment Zones</h3>
                            <p>All our projects are verified along the RRR corridor.</p>
                        </div> */}
                        <img 
                            src={mapImage}
                            alt="Hyderabad Regional Ring Road Map" 
                            className="map-image"
                        />
                        <div className="map-border-accent"></div>
                    </div>

                    {/* --- RIGHT SIDE: Premium Contact Form --- */}
                    <div className={`form-container ${isVisible ? 'fade-in-right' : ''}`}>
                        <div className="form-header">
                            <h2 className="form-title">Secure Your Plot Today</h2>
                            <p className="form-subtitle">Get personalized details on RRR investments.</p>
                        </div>
                        <form onSubmit={handleSubmit} className="premium-form-cta">
                            <div className="form-group-cta">
                                <label htmlFor="name">Full Name</label>
                                <input type="text" id="name" placeholder="John" required />
                            </div>
                            <div className="form-group-cta">
                                <label htmlFor="mobile">Mobile Number</label>
                                <input type="tel" id="mobile" placeholder="+91 98765 43210" required />
                            </div>
                            <div className="form-group-cta">
                                <label htmlFor="email">Email Address</label>
                                <input type="email" id="email" placeholder="email@example.com" />
                            </div>
                            <div className="form-group-cta">
                                <label htmlFor="message">Your Message</label>
                                <textarea id="message" rows="3" placeholder="I am interested in plots near Shadnagar..." />
                            </div>
                            <button type="submit" className="btn-submit-cta">
                                Send Enquiry <Send size={18} />
                            </button>
                        </form>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default LocationCTA;